export const defaultState = {
  inProgressMaternityLeaves: [],
  archivedMaternityLeaves: [],
  maternityLeaveReplacements: [],
  positionsOfReplacement: [],
};
